import { gql } from "@apollo/client";

const schema = {
  create: {
    name: "createModuleType",
    serviceName: "admin",
    query: gql`
      mutation createModuleType(
        $title: String!
        $details: String
      ) {
        createModuleType(
          title: $title
          details: $details
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
